import React, { useCallback, useEffect, useState } from 'react';
import { View, Heading, colors } from '@fairygodboss/ui';
import window from 'global/window';
import Pixel, {
    EmitMetric,
} from '../../../../../Analytics/VisibilityPixel/VisibilityPixel';
import ResponsivePicture from '../../../../../Elements/ResponsivePicture/ResponsivePicture';

export const ContentCard = ({ article, url, hash, type }) => {
    const { contentTitle, contentImage, companyId } = article;
    const [imgKey, setImgKey] = useState(1);
    const [windowWidth, setWindowWidth] = useState(window?.innerWidth);

    const emitClickMetric = () => {
        EmitMetric({
            misc_event_type: 'cta-article-click',
            company_id: [companyId],
            click: 1,
            community_content_key: `${type}-${hash}`,
        });
    };

    /*
    on resize force Responsive image component to rerender by setting a new key
    */
    const windowResize = useCallback(() => {
        const randomNumber = Math.floor(Math.random() * 1001);
        setImgKey(randomNumber + 1);
        const _width = window?.innerWidth;
        if (_width) {
            setWindowWidth(_width);
        }
    }, []);

    useEffect(() => {
        windowResize();
        window.addEventListener('resize', windowResize, { passive: true });
        return () => {
            window.removeEventListener('resize', windowResize);
        };
    }, [windowResize]);

    return (
        <View
            flex={{ _: '0 0 100%', sm: '0 0 50%', md: '0 0 33.333333%' }}
            px={{ _: '0px', sm: '8px', md: '12px' }}
            mt={{ _: '24px', sm: '40px', md: '48px', lg: '56px' }}
        >
            <Pixel
                metrics={{
                    misc_event_type: 'cta-article-impression',
                    misc_event_count: 1,
                    community_content_key: `${type}-${hash}`,
                    company_id: [companyId],
                }}
            />
            <View
                borderRadius="5px"
                as="a"
                href={url}
                target="_self"
                onClick={emitClickMetric}
            >
                <View
                    overflow="hidden"
                    css={{
                        ':hover': {
                            boxShadow: '0 12px 32px rgb(53 53 53 / 24%)',
                        },
                    }}
                    borderRadius="5px"
                    backgroundColor="#FFFFFF"
                    height={{ _: 'inherit', sm: '100%' }}
                    key={`${hash}-${imgKey}`}
                >
                    <View
                        css={{
                            aspectRatio: '500 / 281',
                        }}
                        overflow="hidden"
                        width="100%"
                    >
                        <ResponsivePicture
                            cloudinaryID={contentImage?.src}
                            alt={contentImage?.alt}
                            lazyLoad
                        />
                    </View>
                    <Heading
                        variant={{
                            _: 'headingXs',
                            md: 'headingSm',
                        }}
                        color={colors.neutral[100]}
                        borderRadius="0 0 5px 5px"
                        mx="16px"
                        my="16px"
                        css={{
                            ...(windowWidth > 599
                                ? {
                                      overflow: 'hidden',
                                      display: '-webkit-box',
                                      '-webkit-line-clamp': '3',
                                      '-webkit-box-orient': 'vertical',
                                  }
                                : null),
                        }}
                    >
                        {contentTitle}
                    </Heading>
                </View>
            </View>
        </View>
    );
};
